import React, { useEffect, useState } from 'react';
import i18n from '@i18next/i18n';
import arrowIcon from '@tencent/docs-design-resources/icon/desktop/svg/arrow_left_light_24.svg';
import styles from '@src/slide/application/service/smart-replace-image/replace-dialog/replace-image-dialog.less';

// TODO: 用一个本地图片
const DEFAULT_PNG = 'https://docimg4.docs.qq.com/image/AgAABTW7Ya4hnqF4u2VHSZIAGp6G2s8F.png';

interface IAiReplaceImageContentLeftProps {
    image: string; // 当前的待替换图片
    currentIndex: number; // 待替换图片的序号，展示用
    totalImagesCount: number; // 总共有多少待替换图片，展示用
    changeCurrentImage: (currentIndex: number) => void; // 切换当前的待替换图片，左右箭头用
}

export const AiReplaceImageContentLeft = ({
    image,
    currentIndex,
    totalImagesCount,
    changeCurrentImage,
}: IAiReplaceImageContentLeftProps) => {
    const [showImage, setShowImage] = useState('');
    const [loadingVisible, setLoadingVisible] = useState(true);

    useEffect(() => {
        setShowImage(image);
        setLoadingVisible(true);
    }, [image]);

    // 获取缩略图链接
    const getSmallImageUrl = (image: string) => {
        try {
            const url = new URL(image);
            return `${url.protocol}//${url.hostname}${url.pathname}?imageView2/2/w/400/h/400`;
        } catch (e) {
            return DEFAULT_PNG;
        }
    };

    return (
        <div className={styles['content-left']}>
            <div className={styles['content-subtitle']}>
                {totalImagesCount > 0
                    ? `${i18n.t('正在使用的图片')}  （${currentIndex + 1}/${totalImagesCount}）`
                    : i18n.t('没有智能生成的图片')}
            </div>
            <div className={styles['current-image-container']} hidden={totalImagesCount === 0}>
                <img
                    className={styles['current-image']}
                    src={getSmallImageUrl(showImage)} // 使用缩略图
                    onLoad={() => setLoadingVisible(false)}
                    onError={() => {
                        setLoadingVisible(false);
                        setShowImage(DEFAULT_PNG);
                    }}
                />
                <div className={styles['current-image-loading']} hidden={!loadingVisible} />
                <div
                    className={`${styles['arrow-icon']} ${styles['arrow-icon-before']}`}
                    hidden={currentIndex === 0}
                    onClick={() => changeCurrentImage(currentIndex - 1)}
                >
                    <img className={`${styles['arrow-icon-svg']}`} src={arrowIcon} />
                </div>
                <div
                    className={`${styles['arrow-icon']} ${styles['arrow-icon-after']}`}
                    hidden={currentIndex + 1 >= totalImagesCount}
                    onClick={() => changeCurrentImage(currentIndex + 1)}
                >
                    <img className={`${styles['arrow-icon-svg']}`} src={arrowIcon} />
                </div>
            </div>
        </div>
    );
};
